var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0031 7.03259C16.0031 10.917 12.42 14.0652 8.00153 14.0652C7.20894 14.0661 6.41966 13.9627 5.65388 13.7574C5.06977 14.0547 3.72871 14.6254 1.47228 14.9967C1.27224 15.0289 1.12021 14.8199 1.19943 14.6326C1.5539 13.7927 1.87396 12.6731 1.96998 11.6524C0.744142 10.4179 0 8.80079 0 7.03259C0 3.14819 3.58308 0 8.00153 0C12.42 0 16.0031 3.14819 16.0031 7.03259ZM5.00038 7.03353C5.00038 7.58839 4.55258 8.03819 4.00019 8.03819C3.4478 8.03819 3 7.58839 3 7.03353C3 6.47867 3.4478 6.02888 4.00019 6.02888C4.55258 6.02888 5.00038 6.47867 5.00038 7.03353ZM9.00233 7.03353C9.00233 7.58839 8.55454 8.03819 8.00214 8.03819C7.44975 8.03819 7.00195 7.58839 7.00195 7.03353C7.00195 6.47867 7.44975 6.02888 8.00214 6.02888C8.55454 6.02888 9.00233 6.47867 9.00233 7.03353ZM12.0021 8.03819C12.5545 8.03819 13.0023 7.58839 13.0023 7.03353C13.0023 6.47867 12.5545 6.02888 12.0021 6.02888C11.4498 6.02888 11.002 6.47867 11.002 7.03353C11.002 7.58839 11.4498 8.03819 12.0021 8.03819Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a8c5c491.svg";
export { ForwardRef as ReactComponent };